import { HttpTypes } from "@medusajs/types"
import { Button, cn } from "@/components/common"
import React from "react"
import { useTranslations } from "next-intl"

type OptionSelectProps = {
  option: HttpTypes.StoreProductOption
  current: string | undefined
  updateOption: (title: string, value: string) => void
  title: string
  disabled: boolean
  "data-testid"?: string
}

const OptionSelect: React.FC<OptionSelectProps> = ({
  option,
  current,
  updateOption,
  title,
  "data-testid": dataTestId,
  disabled,
}) => {
  const t = useTranslations('product')
  const filteredOptions = (option.values ?? []).map((v) => v.value)

  return (
    <div className="flex flex-col gap-y-3">
      <span className="text-sm">{t('actions.selectOption', { title })}</span>
      <div
        className="flex flex-wrap justify-between gap-2"
        data-testid={dataTestId}
      >
        {filteredOptions.map((v) => {
          return (
            <Button
              variant="ghost"
              onClick={() => updateOption(option.id, v)}
              key={v}
              className={cn(
                "h-auto p-0 rounded-none font-normal",
                "border-2 text-sm h-10 rounded-lg p-2 flex-1 transition-all duration-150",
                {
                  "border-primary bg-primary/10 font-semibold": v === current,
                  "border-border bg-background hover:border-primary/50 hover:bg-primary/5": v !== current,
                }
              )}
              disabled={disabled}
              aria-pressed={v === current}
              data-testid="option-button"
            >
              {v}
            </Button>
          )
        })}
      </div>
    </div>
  )
}

export default OptionSelect
